<template>
  <div :class="$vuetify.breakpoint.xsOnly ? 'px-4' : ''">
    <v-card :elevation="$vuetify.breakpoint.xsOnly ? 0 : ''" class="mb-4">
      <v-card-title class="subtitle-1 text-uppercase font-weight-medium d-flex align-center">
        <v-icon class="mr-2">mdi-notebook-outline</v-icon>
        {{ $t('quotations.notes.title') }}
        <v-spacer />
        <span v-if="margin != null" class="text-no-wrap text-none">
          <span class="caption grey--text">{{ $t('quotations.notes.margin') }}</span>
          <span class="font-weight-bold ml-1">{{ $formatNumber(margin * 100, '0,0') }} %</span>
        </span>
      </v-card-title>
      <v-card-text>
        <v-alert type="info" text dense class="mb-3">{{ $t('quotations.notes.internal_info') }}</v-alert>
        <v-textarea v-model="quotation.calculationNotes" :disabled="saving" outlined auto-grow rows="12" hide-details class="mb-4" />
        <v-row dense>
          <v-col cols="12" sm="6">
            <numeric-input v-model="quotation.costEstimate" :label="$t('quotations.notes.cost_estimate')" :disabled="saving" suffix="€" outlined dense hide-details>
              <template v-slot:prepend><v-icon>mdi-calculator</v-icon></template>
            </numeric-input>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import NumericInput from '@/components/NumericInput';

export default {
  name: 'QuotationNotesTab',
  components: { NumericInput },
  props: {
    quotation: { type: Object, required: true },
    total: { type: Number, default: 0 },
    saving: { type: Boolean, default: false },
  },
  computed: {
    margin() {
      const cost = this.quotation.costEstimate;
      if (cost == null || !this.total) return null;
      return (this.total - cost) / this.total;
    },
  },
};
</script>
